import gql from "graphql-tag";

export const UPCOMING_PAYMENTS_QUERY = gql`
  query adminUpcomingPayments($date:Date!) {
    adminUpcomingPayments(date:$date) {
      id
      user {
        id
        firstName
        lastName
        email
      }
      billingPeriod
      pausePaymentUntilDate
      migratedFromPayfast
    }
  }
`;

export const CASHFLOW_PROJECTION_QUERY = gql`
query adminCashflowProjectionReport($startDate:Date!, $endDate:Date!) {
  adminCashflowProjectionReport(startDate:$startDate, endDate:$endDate) {
    grandTotal
    days {
      date
      products {
        title
        amount
      }
      amount
    }
  }
}
`;

export const CASHFLOW_PROJECTION_CSV_QUERY = gql`
query adminCashflowProjectionReportCsv($startDate:Date!, $endDate:Date!) {
  adminCashflowProjectionReportCsv(startDate:$startDate, endDate:$endDate)
}
`;

export const FAILED_PAYMENTS_QUERY = gql`
query failedPaymentsReport($startDate:Date!, $endDate:Date!, $productVariants: [String]) {
  failedPaymentsReport(startDate:$startDate, endDate:$endDate, productVariants: $productVariants)
}
`;

export const FAILED_PAYMENTS_QUERY_CSV = gql`
query failedPaymentsReportCsv($startDate:Date!, $endDate:Date!, $productVariants: [String]) {
  failedPaymentsReportCsv(startDate:$startDate, endDate:$endDate, productVariants: $productVariants)
}
`;